module.exports = __webpack_public_path__ + "fba72c4c46798e9ffae47f8538b95a8c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/factory.svg
// module id = 750
// module chunks = 0